import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

function NavLink({ q, dir }) {
  const prev = dir === "prev";
  if (!q) return <span className="hidden flex-1 sm:block" aria-hidden />;
  return (
    <Link
      to={`/question/${q.id}`}
      data-testid={`question-${dir}`}
      className={`group flex min-w-0 flex-1 items-center gap-3 rounded-2xl border border-border bg-card px-4 py-3 transition-colors hover:border-gold ${prev ? "" : "flex-row-reverse text-right"}`}
    >
      {prev ? (
        <ChevronLeft className="h-5 w-5 shrink-0 text-muted-foreground transition-transform group-hover:-translate-x-1 group-hover:text-gold" />
      ) : (
        <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-gold" />
      )}
      <span className="min-w-0">
        <span className="block font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
          {prev ? "Previous" : "Next"} · {q.reference}
        </span>
        <span className="block truncate font-serif text-base text-foreground sm:text-lg">&ldquo;{q.question_kjv}&rdquo;</span>
      </span>
    </Link>
  );
}

export default function QuestionNav({ prev, next, position, total, className = "" }) {
  return (
    <nav className={`flex flex-col gap-3 sm:flex-row sm:items-stretch ${className}`} data-testid="question-nav" aria-label="Question navigation">
      <NavLink q={prev} dir="prev" />
      {position && (
        <span className="hidden shrink-0 items-center self-center font-mono text-[11px] text-muted-foreground sm:flex" data-testid="question-position">
          {position} / {total}
        </span>
      )}
      <NavLink q={next} dir="next" />
    </nav>
  );
}
